export default __webpack_public_path__ + "static/media/sample-home-cluster.bb52d83a.jpg";